import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Game } from '../models/game';
import { ConfigService } from '../services/config.service';
import { BasketballGameTeamStatistic } from '../models/basketball-game-team-statistic';
import { BasketballGameStatistic } from '../models/basketball-game-statistic';
import { BasketballGameLog } from '../models/basketball-game-log';
import { GameBaseApi } from './game-base-api';

@Injectable({providedIn: 'root'})
export class BasketballGameApi extends GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService
  ) {
    super(httpClient, configService);
  }

  async getById(gameId: number): Promise<Game> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/`).pipe(
      map(result => Game.toFront(result))
    ).toPromise();
  }

  async getTeamStatistic(gameId: number): Promise<BasketballGameTeamStatistic> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/team_statistic/`).pipe(
      map(result => BasketballGameTeamStatistic.toFront(result))
    ).toPromise();
  }

  async getUserStatistic(gameId: number): Promise<BasketballGameStatistic[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/user_statistic/`).pipe(
      map(result => BasketballGameStatistic.toFront(result))
    ).toPromise();
  }

  async getLogs(gameId: number): Promise<BasketballGameLog[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/logs/`).pipe(
      map(result => BasketballGameLog.toFront(result))
    ).toPromise();
  }

  async downloadProtocol(gameId: number, fileType: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(
      `${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/game_protocol/?file_type=${fileType}`,
      {responseType: 'blob'}
      )
      .toPromise();
  }

  async downloadFibaProtocol(gameId: number, fileType: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(
      `${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/game_protocol_fiba/?file_type=${fileType}`,
      {responseType: 'blob'}
    )
      .toPromise();
  }

  async downloadMFBApplication(gameId: number, fileType: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/mfb_game_application_file/?file_type=${fileType}`, {
      params: new HttpParams().set('file_type', fileType),
      responseType: 'blob'
    }).toPromise();
  }
}
